export default __webpack_public_path__ + "static/media/pictogramBeaconATM128.f22319e6.svg";